import Alert from '@material-ui/lab/Alert';
import { useDispatch } from 'react-redux';

type IncorrectPasswordAlertProps = {
	message: string;
	alertType: string;
	setLoginMessage: (message: string) => void;
};

export const IncorrectPasswordAlert: React.FC<IncorrectPasswordAlertProps> = ({
	message,
	alertType,
	setLoginMessage
}) => {
	const dispatch = useDispatch();

	return (
		<Alert
			onClose={() => dispatch(setLoginMessage(''))}
			severity="error"
			style={{ background: alertType === 'success' ? '#4CAF50' : '#E2434' }}
			variant="filled"
		>
			{message}
		</Alert>
	);
};
